import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import ZenGauge from "../Common/Graph/ZenGauge";
import AngelaIconMultiR2C from "../Common/Angela/AngelaIconMultiR2C";
import AngelaIcon1R from "../Common/Angela/AngelaIcon1R";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";
import ZenClusterColVer from "../Common/Graph/ZenClusterColVer";
import ZenDonut from "../Common/Graph/ZenDonut";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class SnippetLineOee extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    GaugeOeeLine: null,//Hash
    AngelaTgtActual: null,
    AngelaLineKpiOp: null,
    AngelaLineKpiRej: null,
    AngelaLineKpiCt: null,
    AngelaLineKpiPe: null,
    AngelaLineKpiStoppage: null,
    AngelaLineKpiDt: null,
    ZenVerBarMonthlyDailyTrend: null,
    VerClusterShiftWiseTrend: null,
    VerBarHourlyTrend: null,
    GaugeAPQO_A: null,
    GaugeAPQO_P: null,
    GaugeAPQO_Q: null,
    ZenDonutTimeDistrbution: null,
    dataLoading: false,

    // Houdini_nullData
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("");
    this._isMounted = true;
    this.fetchChartData(); //Hash
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }


  //Hash full func
  fetchChartData = (selectedTab = "all", lid = "all", mnt = "all") => {
    liracrypt
      .get("/chart/charttemplate", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "Snippet1LineOee",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["GaugeOeeLine"] = resp["data"]["GaugeOeeLine"];
        respData["AngelaTgtActual"] = resp["data"]["AngelaTgtActual"];
        respData["AngelaLineKpiOp"] = resp["data"]["AngelaLineKpiOp"];
        respData["AngelaLineKpiRej"] = resp["data"]["AngelaLineKpiRej"];
        respData["AngelaLineKpiCt"] = resp["data"]["AngelaLineKpiCt"];
        respData["AngelaLineKpiPe"] = resp["data"]["AngelaLineKpiPe"];
        respData["AngelaLineKpiStoppage"] =
          resp["data"]["AngelaLineKpiStoppage"];
        respData["AngelaLineKpiDt"] = resp["data"]["AngelaLineKpiDt"];
        respData["ZenVerBarMonthlyDailyTrend"] =
          resp["data"]["ZenVerBarMonthlyDailyTrend"];
        respData["VerClusterShiftWiseTrend"] =
          resp["data"]["VerClusterShiftWiseTrend"];
        respData["VerBarHourlyTrend"] = resp["data"]["VerBarHourlyTrend"];
        respData["GaugeAPQO_A"] = resp["data"]["GaugeAPQO_A"];
        respData["GaugeAPQO_P"] = resp["data"]["GaugeAPQO_P"];
        respData["GaugeAPQO_Q"] = resp["data"]["GaugeAPQO_Q"];
        respData["ZenDonutTimeDistrbution"] = resp["data"]["ZenDonutTimeDistrbution"];

        // Houdini_RespData

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  //   if (this.state.mainData) {  Hash condition

  // {this.state.mainData ?
  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#bdc3c7",
                          fontSize: 28,
                          fontWeight: 400,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                       OEE Analysis
                      </div>

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                      </Row>

                      {/* _______Row No 1________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Row>
                              <ZenGauge
                                divId={"GaugeOeeLine"}
                                data={this.state.GaugeOeeLine.data}
                                config={this.state.GaugeOeeLine.config}
                                onChange={(data) => this.changeBasicGraph(data)}
                              />
                            </Row>
                            <Row>
                              <Col style={{ width: "33%" }}>
                                <ZenGauge
                                  divId={"GaugeAPQO_A"}
                                  data={this.state.GaugeAPQO_A.data}
                                  config={this.state.GaugeAPQO_A.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </Col>

                              <Col style={{ width: "33%" }}>
                                <ZenGauge
                                  divId={"GaugeAPQO_P"}
                                  data={this.state.GaugeAPQO_P.data}
                                  config={this.state.GaugeAPQO_P.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </Col>

                              <Col style={{ width: "33%" }}>
                                <ZenGauge
                                  divId={"GaugeAPQO_Q"}
                                  data={this.state.GaugeAPQO_Q.data}
                                  config={this.state.GaugeAPQO_Q.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </Col>
                            </Row>
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIconMultiR2C
                              divId={"AngelaTgtActual"}
                              data={this.state.AngelaTgtActual.data}
                              config={this.state.AngelaTgtActual.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"AngelaLineKpiOp"}
                              data={this.state.AngelaLineKpiOp.data}
                              config={this.state.AngelaLineKpiOp.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"AngelaLineKpiRej"}
                              data={this.state.AngelaLineKpiRej.data}
                              config={this.state.AngelaLineKpiRej.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"AngelaLineKpiCt"}
                              data={this.state.AngelaLineKpiCt.data}
                              config={this.state.AngelaLineKpiCt.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"AngelaLineKpiPe"}
                              data={this.state.AngelaLineKpiPe.data}
                              config={this.state.AngelaLineKpiPe.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"AngelaLineKpiStoppage"}
                              data={this.state.AngelaLineKpiStoppage.data}
                              config={this.state.AngelaLineKpiStoppage.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"AngelaLineKpiDt"}
                              data={this.state.AngelaLineKpiDt.data}
                              config={this.state.AngelaLineKpiDt.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                        <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                            width: "95%",
                          }}
                        >
                          <ZenDonut
                            divId={"ZenDonutTimeDistrbution"}
                            // api={'/chart/charttemplate'}
                            // urlData={{
                            //   lid: 'all',
                            //   mnt: 'all',
                            //   typ: "MainGraph",
                            //   subTyp: this.state.selectedTab,
                            //   chartGroup: "ZenChartArsenal",
                            // }}
                            data={
                              this.state.ZenDonutTimeDistrbution
                                .data
                            }
                            config={
                              this.state.ZenDonutTimeDistrbution
                                .config
                            }
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                        </Col>


                      </Row>

                      {/* _______Row No 8________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "50%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"ZenVerBarMonthlyDailyTrend"}
                              data={this.state.ZenVerBarMonthlyDailyTrend.data}
                              config={
                                this.state.ZenVerBarMonthlyDailyTrend.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenClusterColVer
                              divId={"VerClusterShiftWiseTrend"}
                              data={this.state.VerClusterShiftWiseTrend.data}
                              config={
                                this.state.VerClusterShiftWiseTrend.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"VerBarHourlyTrend"}
                              data={this.state.VerBarHourlyTrend.data}
                              config={this.state.VerBarHourlyTrend.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 9________ */}

                      {/* Houdini_DivData */}
                    </div>
                  ) : null}
                </Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default SnippetLineOee;
